<template>
  <div class="map-title" :style="{marginTop: marginTop + 'rem'}">
    <div class="text">{{data.title}}</div>
    <div :style="{width: data.tab.length * 1.1 + 'rem'}" class="tab">
      <div 
        @click="setCurTab(index)" 
        :class="{ current: curTab2 == index }" 
        :key="index" 
        :style="{width: 100 / data.tab.length + '%'}" 
        v-for="(item, index) in data.tab">{{item}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapTitle',
  props: {
    data: Object,
    curTab: {
      type: Number,
      default: 0
    },
    marginTop: {
      type: Number,
      default: 0.3
    }
  },
  data() {
    return {
      curTab2: this.curTab
    }
  },
  methods: {
    setCurTab(val) {
      this.curTab2 = val
      this.$emit('getCurTab', val)
    }
  }
}
</script>

<style scoped lang="less">
.map-title {
  width: 50%;
  height: 0.3rem;
  margin: auto;
  color: @light-blue;
  font-size: 0.2rem;
  font-weight: bold;
  position: relative;
  z-index: 9999;
  .tab {
    height: 0.22rem;
    margin: 0.1rem auto;
    > div {
      height: 100%;
      font-size: 0.14rem;
      line-height: 0.23rem;
      color: @base-text-color;
      float: left;
      cursor: pointer;
      background: url(../../assets/spot_tab_bg.png);
      background-size: 100% 100%;
    }
    .current {
      background: url(../../assets/tab_bg_cur.png);
      background-size: 100% 100%;
    }
  }
}
</style>
